if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"TRAFFIX_UI_SHELL","remotes":[{"alias":"COMMON_APP","name":"COMMON_APP","entry":"https://app.traffix.com/common-mfe/remoteEntry.js?v=1769622859217","shareScope":"default"}]},
		chunkMatcher: function(chunkId) {return !/^(6(050|35|843)|2040|5453|5666|7293|8326)$/.test(chunkId)},
		rootOutputDir: "../../",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}